<template>
  <Layout :company="model" :use_language="true" :selected_language="selected_language" @changeLang="changeLang">
		<div class="text-center loaderko" v-if="loading">
			<div class="spinner-grow text-primary m-2" role="status">
				<span class="sr-only">Loading...</span>
			</div>
			<div class="text-muted small">Loading</div>
		</div>
		<div class="card p-4 col-md-5 mx-auto mt-5">
			<div class="text-center" v-if="success">
				Thank you for acknowledging.
			</div>

			<div class="text-center" v-if="declined">
				Acknowledge was declined.
			</div>
			<div v-if="!success && !declined">
				<div class="text-left" v-if="selected_language == 'us'">
					<h3 class="mt-0">Hello {{getFullName}} !</h3>
					<h5 class="mt-0">Personal Information Protection Policy</h5>

					<p class="mb-2 mx-auto">
						JINZ.AI K.K. ("JINZ.AI") provides recruiting services in Japan. In operating its business,
						JINZ.AI must handle a great deal of personal information concerning candidates, clients, and
						employees. Therefore, JINZ.AI has established this Policy along with a personal information
						management system through which JINZ.AI, as a company, commits to meeting its
						responsibility in protecting personal information.
					</p>

					<p class="mb-2 mx-auto">
						<b>Policy 1:</b> JINZ.AI will, to the extent possible, specify the purposes for utilizing the personal
						information, and will properly handle the personal information within the scope necessary to
						achieve such purposes. JINZ.AI will take measures to ensure the prevention of personal
						information being used other than for the intended purposes.
					</p>

					<p class="mb-2 mx-auto">
						<b>Policy 2:</b> JINZ.AI will obtain personal information only through legitimate and appropriate means.
					</p>
					
					<p class="mb-2 mx-auto">
						<b>Policy 3:</b> JINZ.AI will not provide any personal information of any individual to a third party without the consent of that individual.
					</p>

					<p class="mb-2 mx-auto">
						<b>Policy 4:</b> In managing personal information, JINZ.AI will make efforts to take all necessary
						and appropriate measures to ensure the prevention and correction of any leakage, loss or
						damage of the personal information, as well as for other safety management factors.
					</p>

					<p class="mb-2 mx-auto">
						<b>Policy 5:</b> In handling personal information, JINZ.AI will make efforts to ensure that the
						individual who has provided the information shall be properly involved in the handling
						process, and to keep the personal information accurate and updated to the extent possible.
					</p>

					<p class="mb-2 mx-auto">
						<b>Policy 6:</b> JINZ.AI will comply with laws and regulations pertaining to the protection of
						personal information, and will establish, review continuously, and comply with the internal
						rules pertaining to the protection of personal information.
					</p>

					<p class="mb-2 mx-auto">
						<b>Policy 7:</b> JINZ.AI will establish a contact window to correspond to complaints and
						consultations concerning the protection of personal information and make efforts to properly
						respond to such complaints and consultations.
					</p><br/>

					<p class="mb-2 mx-auto">
						<b>Mehdi Iraqi, CEO<br/>
						JINZ.AI K.K.</b>
					</p><br/>

					<p class="mb-2 mx-auto">
						<b>Regarding the Handling of Personal Information</b>
					</p>

					<p class="mb-2 mx-auto">
						JINZ.AI K.K.(“JINZ.AI") shall uphold this privacy policy, shall respect the privacy of
						companies, affiliated companies, associations, etc., that use the services provided in
						accordance with this privacy policy ("Services") (“Service Using Companies, etc.”) and each
						person ("Candidate") who uses the services and shall handle the personal information (as
						defined below) of all Users with the utmost care in its management thereof.
					</p>

					<p class="mb-2 mx-auto">
						<b>Personal information</b>
					</p>

					<p class="mb-2 mx-auto">
						Personal information is the information of a Candidate as an individual, which can identify
						the Candidate based on the name, address, telephone number, e-mail address, educational
						institution, or other descriptions, etc. which constitutes such information. In addition, any
						information which may not identify the Candidate solely by itself but can easily be
						cross-referenced with other information to identify the Candidate as a result, is also included
						in the scope of personal information.
					</p>

					<p class="mb-2 mx-auto">
						<b>Purposes of use of personal information</b>
					</p>

					<p class="mb-2 mx-auto">
						JINZ.AI shall use personal information only for the following purposes, and shall not use any
						personal information beyond these purposes of use:
					</p><br/>

					<p class="mb-2 mx-auto">
						<b>Purposes of use of personal information</b>
					</p>

					<p class="mb-2 mx-auto">
						● Provision of information and services concerning job referrals, employment, career
						change, and Professional Resourcing Service (hereinafter “PRS”).<br/>
						● Provision of personal information to Service Using Companies, etc., based on
						Candidates’ consent/application.<br/>
						● Listening in on opinions or requests aimed at confirming Candidates’ situation after
						employment or dispatching, and improving services.<br/>
						● Confirmation of the candidate’s application and commence as well as receiving
						notices from Service Using Companies during and after the period of service
						provision.<br/>
						● Statistically processing and analyzing information for publication on websites and
						other media.<br/>
						● Development and marketing of new services.<br/>
						● Advising and proposing recruitment plans for companies seeking workers.<br/>
						● Managing inquiries, consultations and complaints, and/or resolving disputes.<br/>
						● Hiring operations for JINZ.AI.<br/>
						● Making contact through generally shared information, such as publications and
						websites.
					</p>

					<p class="mb-2 mx-auto">
						<b>Voluntary nature of providing personal information</b>
					</p>

					<p class="mb-2 mx-auto">
						Although it is not necessary to provide all of the items asked for, if a Candidate fails to
						answer necessary question(s), such Candidate may not be able to obtain the services
						JINZ.AI provides.
					</p>

					<p class="mb-2 mx-auto">
						<b>Disclosure of personal information to the third party</b>
					</p>

					<p class="mb-2 mx-auto">
						JINZ.AI, as a recruiting agency, will provide personal information (limited to Company name,
						position title, job description etc.) obtained from the Candidate or from public source, after
						examining the Candidate’s requests and adequacy, by sending or carrying the document to
						contracted companies who have agreed to the articles of properly handling personal
						information
					</p><br/>

					<p class="mb-2 mx-auto">
						However, personal information may be disclosed without Candidates’ consent within the
						confines of applicable laws and regulations when:
					</p>

					<p class="mb-2 mx-auto">
						A) The Candidate is considered detrimental to the third party.
					</p>

					<p class="mb-2 mx-auto">
						B) The provision of personal information is especially necessary for improving public hygiene
						or promoting the sound growth of children and it is difficult to obtain the consent of the
						Candidate.
					</p>

					<p class="mb-2 mx-auto">
						C) The provision of personal information is necessary for cooperating with a state institution,
						a local public body, or an individual or entity entrusted by such an institution or body to
						execute operations prescribed by law and
					</p>

					<p class="mb-2 mx-auto">
						D) A court, prosecutor’s office, police department, or any other institution with corresponding
						authority requests disclosure of the Candidate’s personal information.
					</p>

					<p class="mb-2 mx-auto">
						E) The Candidate him/herself explicitly requests the provision or disclosure to the third party.
					</p>

					<p class="mb-2 mx-auto">
						F) The disclosure and provision of personal information is allowed by laws and regulations.
					</p>

					<p class="mb-2 mx-auto">
						G) The provision of personal information occurs as a result of business succession in a
						merger or otherwise and is utilized within the purpose range set before the succession.
					</p>

					<p class="mb-2 mx-auto">
						<b>Outsourcing of personal information handling process</b>
					</p>

					<p class="mb-2 mx-auto">
						JINZ.AI may outsource partial or all of the personal information handling duties. JINZ.AI shall
						be responsible for the handling of personal information by the outsourcing contractor.
					</p><br/>

					<p class="mb-2 mx-auto">
						<b>Use of statistically-processed data</b>
					</p>

					<p class="mb-2 mx-auto">
						JINZ.AI may, based on the provided personal information, create statistical data which shall
						be processed in a manner that cannot identify any individual. JINZ.AI may, without
						restriction, use statistical data that cannot identify individuals.
					</p><br/>

					<p class="mb-2 mx-auto">
						<b>Disclosure etc. of personal information</b>
					</p>

					<p class="mb-2 mx-auto">
						In the event a Candidate requests for a notice, disclosure, correction, addition / deletion,
						suspension, or elimination for the use of Candidate’s personal information or suspension of
						provision to the third party, JINZ.AI shall take prompt actions according to its internal
						regulations. However, in cases where complying with such requests might impede necessary
						operations, JINZ.AI may not be able to accommodate the request for disclosure, correction,
						deletion, suspension or elimination of information.
					</p><br/>

					<p class="mb-2 mx-auto">
						<b>Accuracy of personal information</b>
					</p>

					<p class="mb-2 mx-auto">
						JINZ.AI shall make efforts to accurately process the personal information provided. However,
						Candidates are to be responsible for ensuring that the personal information they provide is
						accurate and up-to-date.
					</p><br/>

					<p class="mb-2 mx-auto">
						<b>Restrictions on acquisition of sensitive personal information</b>
					</p>

					<p class="mb-2 mx-auto">
						JINZ.AI, as a general rule, shall not obtain any Candidate’s personal information which
						containing any of the following information unless the personal information has been
						provided by the Candidate himself/herself:
					</p>

					<p class="mb-2 mx-auto">
						A) Information relating to personal philosophy, belief or religion.
					</p>

					<p class="mb-2 mx-auto">
						B) Information relating to race, ethnic background, family background, domicile (except for
						information on the prefecture where the Candidate is located), physical or mental disability,
						criminal record or other matters that may cause social discrimination.
					</p>

					<p class="mb-2 mx-auto">
						C) Information relating to the right to organize, or any acts of collective bargaining or other
						collective actions as a worker.
					</p>

					<p class="mb-2 mx-auto">
						D) Information relating to participation in acts of mass demonstration, exercising of petition
						rights or other political rights.
					</p>

					<p class="mb-2 mx-auto">
						E) Information relating to health and medical conditions or sex life.
					</p><br/>

					<p class="mb-2 mx-auto">
						<b>Modifications to Privacy Policy</b>
					</p>

					<p class="mb-2 mx-auto">
						Unless otherwise stated in laws and regulations, etc., JINZ.AI shall be entitled to modify this
						Privacy Policy as needed.
					</p>

					<p class="mb-2 mx-auto">
						<b>Inquiries</b>
					</p>

					<p class="mb-2 mx-auto">
						Please contact <a href="mailto:privacy@jinz.ai">privacy@jinz.ai</a>. for any inquiries regarding the handling of personal
						information, and for requests regarding personal information for notice of purpose of use, or
						disclosure, correction, addition or deletion or discontinuation of use, erasure or
						discontinuance of provision to a third party.
					</p>

					<p>Please click on the acknowledge button to show your agreement with the conditions mentioned above and to proceed with your application.</p>

				</div>
				<div class="text-left" v-else>
					<h3 class="mt-0">Hello {{getFullName}} !</h3>
					<h5 class="mt-0">個人情報保護方針</h5><br/>

					<p class="mb-2 mx-auto">
						JINZ.AI株式会社は、外資系企業・日系グローバル企業を対象に人材紹介事業を行っておりま
						す。当社では事業運営上多くのお客様や従業者の個人情報を取扱うこととなるため、本方針を
						定め、個人情報管理体制を確立し、企業として責任ある対応を実現するものとします。
						方針1.  個人情報の利用の目的をできる限り特定し、当該目的の達成に必要な範囲内で適切に
						取扱います。また、目的外利用を行なわないための措置を講じます。
						方針2.  個人情報は、適法かつ適正な方法で取得します。
						方針3.  個人情報は、本人の同意なく第三者に提供しません。
						方針4.  個人情報の管理にあたっては、漏洩・滅失・毀損の防止及び是正、その他の安全管理
						のために必要かつ適切な措置を講じるよう努めます。
						方針5.  個人情報の取扱いにあたっては、その情報を提供した本人が適切に関与し得るよう努
						め、可能な限り正確かつ最新の内容に保つよう努力します。
						方針6.  個人情報保護に関する法令を遵守し、また個人情報保護に関する社内規程を定め、継
						続的な見直しを行い遵守します。
						方針7.  個人情報保護に関する苦情及び相談に対応する窓口を設けて、適切に対応するよう努
						めます。
					</p><br/>

					<p class="mb-2 mx-auto">
						<b>JINZ.AI</b>株式会社
						代表取締役  伊良木 メディ
					</p><br/>

					<p class="mb-2 mx-auto">
						（附則）
					</p><br/>

					<p class="mb-2 mx-auto">
						個人情報の取扱いについて
					</p><br/>

					<p class="mb-2 mx-auto">
						JINZ.AI株式会社(JINZ.AI)（以下「当社」といいます）は、当プライバシーポリシーを掲示し、
						当プライバシーポリシーに準拠して提供されるサービス（以下「本サービス」といいます）の利用
						企業・提携企業・団体等（以下「利用企業等」といいます）および本サービスをご利用になる方（以
						下「キャンディデート」といいます）のプライバシーを尊重し、個人情報（以下の定義に従います）
						の管理に細心の注意を払い、これを取扱うものとします。
					</p><br/>

					<p class="mb-2 mx-auto">
						◆ 個人情報
					</p><br/>

					<p class="mb-2 mx-auto">
						個人情報とは、個人に関する情報であって、当該情報を構成する氏名、住所、電話番号、メール
						アドレス、学校名その他の記述等により当該個人を識別できるものをいいます。また、その情報
						のみでは識別できない場合でも、他の情報と容易に照合することができ、結果的に個人を識別で
						きるものも個人情報に含まれます。
					</p><br/>

					<p class="mb-2 mx-auto">
						◆ 個人情報の利用目的
					</p><br/>

					<p class="mb-2 mx-auto">
						個人情報の利用目的は以下の通りです。利用目的を超えて利用することはありません。
					</p><br/>

					<p class="mb-2 mx-auto">
						職業紹介、就職・転職、人材派遣に関する情報提供およびこれらに関連するサービスの提供
						キャンディデートの承諾・申込みに基づく、本サービスの利用企業等への個人情報の提供
						就職・転職・派遣後の状況確認およびサービス向上を目的としたご意見、ご要望等の聴取
						サービス提供期間中またはサービス終了後における応募、入社等の事実に関する求人企業へ
						の確認および求人企業からの通知の受領
						ウェブサイトその他各種媒体等に掲載するための情報の加工、統計および分析
					</p><br/>

					<p class="mb-2 mx-auto">
						サービスの開発およびマーケティング
						求人企業の人材採用計画立案のための助言・提案
						お問い合わせ、ご相談および苦情への対応ならびに紛争の解決
						当社の採用に関する業務遂行
						刊行物やインターネット等の公開情報等をもとにしたご連絡
					</p><br/>

					<p class="mb-2 mx-auto">
						◆ 個人情報提供の任意性
					</p><br/>

					<p class="mb-2 mx-auto">
						当社が提供を求めるすべての項目にお答えいただく必要はありませんが、必要な情報が不足し
						ている場合には、当社のサービスを提供できない場合があります。
					</p><br/>

					<p class="mb-2 mx-auto">
						◆ 個人情報の第三者への提供
					</p><br/>

					<p class="mb-2 mx-auto">
						当社は、職業紹介を行うため、本人の希望や求人への適合度合いなどを検討した上で、個人情
						報の適切な取り扱いに関する事項を含む契約を結んだ企業に対し、本人から受領した個人情報
						または公開されている個人情報のうち企業名、役職名、職務内容等を、書面を送付または持参
						する等の方法により提供します。
					</p><br/>

					<p class="mb-2 mx-auto">
						ただし、以下の場合は、関係法令に反しない範囲で、本人の同意なく個人情報を提供することが
						あります。
					</p><br/>

					<p class="mb-2 mx-auto">
						A. 本人が第三者に不利益を及ぼすと判断した場合
					</p><br/>

					<p class="mb-2 mx-auto">
						B. 公衆衛生の向上または児童の健全な育成の推進のために特に必要がある場合であって、本
						人の承諾を得ることが困難である場合
					</p><br/>

					<p class="mb-2 mx-auto">
						C. 国の機関若しくは地方公共団体またはその委託を受けた者が法令の定める事務を遂行する
						ことに対して協力する必要がある場合で、本人の同意を得ることによりその事務の遂行に支障を
						及ぼすおそれがある場合
					</p><br/>

					<p class="mb-2 mx-auto">
						D. 裁判所、検察庁、警察またはこれらに準じた権限を有する機関から、個人情報についての開
						示を求められた場合
					</p><br/>

					<p class="mb-2 mx-auto">
						E. 本人から明示的に第三者への開示または提供を求められた場合
					</p><br/>

					<p class="mb-2 mx-auto">
						F. 法令により開示または提供が許容されている場合
					</p><br/>

					<p class="mb-2 mx-auto">
						G. 合併その他の事由による事業の承継に伴い個人情報を提供する場合であって、承継前の利
						用目的の範囲で取り扱われる場合
					</p><br/>

					<p class="mb-2 mx-auto">
						◆ 個人情報処理の外部委託
					</p><br/>

					<p class="mb-2 mx-auto">
						当社は、個人情報取扱い業務の一部または全部を外部委託することがあります。なお、委託先
						における個人情報の取扱いについては当社が責任を負います。
					</p><br/>

					<p class="mb-2 mx-auto">
						◆ 統計処理されたデータの利用
					</p><br/>

					<p class="mb-2 mx-auto">
						当社は、提供を受けた個人情報をもとに、個人を特定できないよう加工した統計データを作成す
						ることがあります。個人を特定できない統計データについては、当社は何ら制限なく利用すること
						ができるものとします。
					</p><br/>

					<p class="mb-2 mx-auto">
						◆ 個人情報の開示等
					</p><br/>

					<p class="mb-2 mx-auto">
						個人情報の利用目的の通知、開示、訂正、追加または削除、利用の停止、消去または第三者へ
						の提供の停止の依頼を受けた場合は、当社の社内規定に従ってすみやかに対応します。ただ
						し、当社の業務に支障がある場合や業務の記録については、開示、訂正、追加または削除、利
						用の停止、消去または第三者への提供の停止の依頼にお応えできない場合があります。
					</p><br/>

					<p class="mb-2 mx-auto">
						◆ 個人情報の正確性
					</p><br/>

					<p class="mb-2 mx-auto">
						当社は、ご提供いただいた個人情報を正確にデータ処理するように努めます。ただし、ご提供い
						ただいた個人情報の内容が正確かつ最新であることについては、本人が責任を負うものとしま
						す。
					</p><br/>

					<p class="mb-2 mx-auto">
						◆ 機微な個人情報の取得制限
					</p><br/>

					<p class="mb-2 mx-auto">
						当社は、次に示す内容を含む個人情報の取得は原則として行いません。ただし、本人が自ら提
						供した場合は、この限りではありません。
					</p><br/>

					<p class="mb-2 mx-auto">
						A. 思想、信条及び宗教に関する事項
					</p><br/>

					<p class="mb-2 mx-auto">
						B. 人種、民族、門地、本籍地（所在都道府県に関する情報を除く）、身体・精神障害、犯罪歴、そ
						の他社会的差別の原因となる事項
					</p><br/>

					<p class="mb-2 mx-auto">
						C. 勤労者の団結権、団体交渉及びその他団体行動の行為に関する事項
					</p><br/>

					<p class="mb-2 mx-auto">
						D. 集団示威行為への参加、請願権の行使、及びその他政治的権利の行使に関する事項
					</p><br/>

					<p class="mb-2 mx-auto">
						E. 保健医療及び性生活
					</p><br/>

					<p class="mb-2 mx-auto">
						◆ 個人情報管理責任者
					</p><br/>

					<p class="mb-2 mx-auto">
						当社は統括情報管理責任者を個人情報管理責任者とし、適切な個人情報の保護に努めます。
					</p><br/>

					<p class="mb-2 mx-auto">
						◆ プライバシーポリシーの変更
					</p><br/>

					<p class="mb-2 mx-auto">
						当社は法令等の定めがある場合を除き、プライバシーポリシーを随時変更することができるもの
						とします。
					</p><br/>

					<p class="mb-2 mx-auto">
						◆ 問い合わせ先
					</p><br/>

					<p class="mb-2 mx-auto">
						個人情報管理に関するお問い合わせや、利用目的の通知、開示、訂正、追加または削除、利用
						の停止、消去または第三者への提供の停止の依頼は、「<a href="mailto:privacy@jinz.ai">privacy@jinz.ai</a>」宛にご連絡ください。
					</p><br/>

					<p v-if="selected_language == 'us'">Please click on the acknowledge button to show your agreement with the conditions mentioned above and to proceed with your application.</p>
					<p v-else>（日本語）: 上記の条件に同意された場合は、「確認」ボタンをクリックして、お申し込みを進めてください。</p>
				</div>
				<hr>
					<button class="btn2 btn2-primary btn2-md btn-block" @click="onAccept"><i class="uil-message"></i> {{selected_language == 'us' ? 'Acknowledge' : '確認'}}</button> 
					<button class="btn btn-soft-danger btn-block" @click="onDecline">{{selected_language == 'us' ?  'Decline' : '辞退'}}</button>
			</div>
		</div>
  </Layout>
</template>

<script>
import Layout from '@layouts/basic'
import { mapActions } from 'vuex'
import moment from 'moment/moment'
import  FormMixin from '@mixins/form'
// import DropDown from '@components/form/dropdown.vue'

export default {
	mixins:[FormMixin],
	components: {Layout},
	name: 'Login',
	data() {
		return {
			model:{},
			declined:false,
			success:false,
			selected_language:'us'
		}
	},
	computed:{
		getFullName(){
			let pros = this.model.prospect || this.model.candidate_id
		
			return pros ? pros.full_name : ''
		}
	},
	async created(){
		await this.getData()
		this.acceptOrDecline()
	},
	methods:{
		...mapActions('prospect', ['getAcknowledgement', 'acknowledge', 'declineAcknowledge']),
		async getData(){
			await this.getAcknowledgement({
				token:this.$route.query.key
			}).then(res => {
				if(res.data.application){
					this.model = res.data.application
				}else{
					this.$router.push('/')
				}
			})
		},
		acceptOrDecline(){
			if(this.$route.query.accepted == true){
				this.onAccepted()
			}else if(this.$route.query.declined == true){
				this.onDeclined()
			}
		},
		onAccepted(){
			this.toggleLoading()
			this.acknowledge({
				id:this.model._id
			}).then(res => {
				if(res.data){
					this.$bvToast.toast(`Acknowledgement was successfully executed.`, {
						title: 'Notification',
						variant:'success'
					})
					this.model = res.data
					this.success = true
				}

				this.toggleLoading()
			})
		},
		onDeclined(){
			this.toggleLoading()
			this.declineAcknowledge({
				id:this.model._id
			}).then(res => {
				if(res.data){
					this.$bvToast.toast(`You've successfully decline.`, {
						title: 'Notification',
						variant:'success'
					})
					this.model = res.data
					this.declined = true
				}

				this.toggleLoading()
			})
		},
		onAccept(){

			this.$bvModal.msgBoxConfirm(
				`Are you sure you want to acknowledge and proceed to next step?`, 
			{
        title: 'Please Confirm Action',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'success',
        okTitle: 'ACKNOWLEDGE',
        cancelTitle: 'CANCEL',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      }).then(res => {
        if(res == true){
					this.toggleLoading()

					this.acknowledge({
						id:this.model._id
					}).then(res => {
						if(res.data){
							this.$bvToast.toast(`Acknowledgement was successfully executed.`, {
								title: 'Notification',
								variant:'success'
							})
							this.model = res.data
							this.success = true
						}

						this.toggleLoading()
					})
        }
      })
		},
		changeLang(lang){
			this.selected_language = (lang == 'us' ? 'jp' : 'us')
		},
		onDecline(){
			this.$bvModal.msgBoxConfirm('Are you sure you want to decline?', {
        title: 'Please Confirm Action',
        size: 'sm',
        buttonSize: 'sm',
        okVariant: 'danger',
        okTitle: 'DECLINE?',
        cancelTitle: 'CANCEL',
        footerClass: 'p-2',
        hideHeaderClose: false,
        centered: true
      }).then(res => {
        if(res == true){
					this.toggleLoading()
					this.declineAcknowledge({
						id:this.model._id
					}).then(res => {
						if(res.data){
							this.$bvToast.toast(`You've successfully decline.`, {
								title: 'Notification',
								variant:'success'
							})
							this.model = res.data
							this.declined = true
						}

						this.toggleLoading()
					})
        }
      })
		},
	},
	filters:{
    date:function(v){
      return v ? moment(v).format('MMM DD, YYYY') : 'N/A'
    }
	}
}
</script>

<style lang="scss">
.flatpickr-calendar{
	margin:auto;
}
.flatpickr-disabled{
	color: #dfdfdf !important;
	font-weight: normal !important;
}
.flatpickr-day{
	color: green;
	font-weight: 900;
}
.loaderko{
  position: absolute;
  height: 100%;
  z-index: 9;
  background: #ffffffc7;
  width: 100%;
  /* vertical-align: middle; */
  /* margin: auto; */
}
</style>

